import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MainRoutingPathsEnum } from '@/shared/config/main-routing-paths.enum';

/**
 * Считает переходы по страницам приложения (кроме /not-found) с момента его загрузки.
 * Нужен кнопке «Назад» на странице 404: она возвращается по истории, только если до 404
 * была хотя бы одна живая страница (иначе history.back() уведёт из приложения или вернёт
 * на страницу, которая снова упадёт в 404). Редирект на /not-found в auth.interceptor
 * идёт с replaceUrl, поэтому битая страница в истории не остаётся.
 */
@Injectable({ providedIn: 'root' })
export class NavigationTrackingService {
  private liveNavigations: number = 0;

  constructor(router: Router) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd && !NavigationTrackingService.isNotFoundUrl(event.url)) {
        this.liveNavigations++;
      }
    });
  }

  private static isNotFoundUrl(url: string): boolean {
    const notFound = `/${MainRoutingPathsEnum.NotFound}`;
    return url === notFound || url.startsWith(`${notFound}/`);
  }

  get hasInAppHistory(): boolean {
    return this.liveNavigations > 1;
  }
}
